import angular from 'angular';
import responseComponent from './response.component';
import PayResponseService from './response.service';
import responseConfig from './response.config';

let responseModule = angular.module('app.payZone.response',[])
  .component('payResponse', responseComponent)
  .service('PayResponseService', PayResponseService)
  .config(responseConfig);

export default responseModule;



// WEBPACK FOOTER //
// ./www/components/pay-zone/response/response.js